class CardColorSwatches extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', this.onSwatchClick.bind(this));
  }

  onSwatchClick(event) {
    const button = event.target.closest('.card-color-swatch');
    if (!button) return;

    const card = this.closest('.card-product, .card-wrapper');
    const img = card?.querySelector('.card__media img');
    if (!img) return;

    img.src = button.dataset.imageSrc;
    if (button.dataset.imageSrcset) img.srcset = button.dataset.imageSrcset;
    if (button.dataset.imageAlt) img.alt = button.dataset.imageAlt;

    this.querySelectorAll('.card-color-swatch').forEach((b) =>
      b.classList.toggle('is-active', b === button)
    );
  }
}

customElements.define('color-swatches', CardColorSwatches);